import image_white from '../../../public/logo_white.svg';
import { useLineLinkage } from '../../hooks/useLineLinkage';
import { useAuth, useLineAccount } from '@raysee/hooks';
import { ArrowBackLeftIcon } from '@raysee/icon';
import { Modal } from '@raysee/ui';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { FC, useState } from 'react';

type Props = {
  title?: string;
  callBackLink?: string;
};

export const Header = ({ title, callBackLink }: Props) => {
  const router = useRouter();
  const [auth] = useAuth();
  const { execute: lineLinkage } = useLineLinkage();
  const [lineAccount] = useLineAccount(auth?.uid ?? '');
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="bg-brand sticky top-0 z-50 flex items-center justify-between px-4 py-2">
        <div className="pt-0.5">
          {title ? (
            <div className="flex h-[41px] max-w-[80vw] items-center truncate text-white">
              {callBackLink ? (
                <ArrowBackLeftIcon
                  fill={'#FFFFFF'}
                  onClick={() => router.push(callBackLink)}
                  className="shrink-0 cursor-pointer"
                />
              ) : null}
              <span className="truncate pl-5 text-sm font-bold">{title}</span>
            </div>
          ) : (
            <Link href="/" className="cursor-pointer pt-0.5" legacyBehavior>
              <Image src={image_white} width="110" height="35" alt="logo" />
            </Link>
          )}
        </div>
        <div>
          {auth && !lineAccount && (
            <button
              onClick={() => {
                if (!auth) return;
                setOpen(true);
              }}
            >
              <Image src="/line_linkage.png" alt="line_linkage" width={130} height={35} />
            </button>
          )}
        </div>
      </header>
      <LineGuideModal
        open={open}
        onConfirm={() => {
          if (!auth) return;
          lineLinkage(auth.uid);
          setOpen(false);
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

interface LineGuideModalProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const LineGuideModal: FC<LineGuideModalProps> = ({ open, onConfirm, onClose }) => (
  <Modal isOpen={open} onClose={onClose}>
    <button onClick={onConfirm}>
      <Image src="/line_link.png" alt="line_link" width={343} height={408} />
    </button>
  </Modal>
);
